import { LoadingButton } from "@mui/lab";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import AnalyticsIcon from "src/assets/icon/Analytics";
import CloseModalButton from "src/assets/icon/close/CloseModalButton";
import { PostAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";
import useLocales from "src/hooks/useLocales";
interface Module {
  id: number;
  name: string;
  description: string;
  image: string;
  disabled: boolean;
}

const PermissionModal = ({ open, handleClose, moduleName = "Analytics" }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const { translate } = useLocales();
  const contactSales = () => {
    setLoading(true);
    PostAsync(
      `${API_GATEWAY}/api/userservice/Organization/modules/${moduleName}/contact`,
      {}
    ).then((res) => {
      if (res.status === 200) {
        enqueueSnackbar(translate("Request send successfully"));
      } else if (res.status === 400) {
        if (res.data?.Detail) {
          enqueueSnackbar(translate(res.data?.Detai), { variant: "error" });
        } else {
          enqueueSnackbar(translate("An error occurred"), { variant: "error" });
        }
      }
      setLoading(false);
    });
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 20,
            top: 20,
            width: 10,
            height: 8,
          }}
          size="small"
        >
          <CloseModalButton />
        </IconButton>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            bgcolor: "#F5FBFF",
            flexGrow: 1,
          }}
        >
          <Box
            sx={{
              width: "40%",
              p: 2.5,
              justifyContent: "space-between",
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <AnalyticsIcon color={"#32AEFF"} />
                <Typography
                  variant="h3"
                  // color={"text.primary"}
                  color={"#32AEFF"}
                >
                  {moduleName}
                </Typography>
              </Box>
              <Typography variant="body2">
                Enhance collaboration and transparency with a dedicated
                suppliers portal. Allow your suppliers to track invoices,
                payments, and communicate directly, fostering stronger
                relationships and trust.
              </Typography>
            </Box>
            <Box>
              <LoadingButton
                loading={loading}
                onClick={contactSales}
                variant="contained"
                sx={{
                  width: "100%",
                }}
              >
                Contact sales
              </LoadingButton>
            </Box>
          </Box>
          <Box sx={{ width: "60%", bgcolor: "secondary.light" }}>
            <img
              style={{
                height: "100%",
                objectFit: "cover",
              }}
              src={
                "https://cdn.dribbble.com/userupload/18674152/file/original-298a81985d97b89fcaf4688988437b3c.webp?resize=1200x900&vertical=center"
              }
            />
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default PermissionModal;
